export var PipeErrorCodes;
(function (PipeErrorCodes) {
    PipeErrorCodes["ElementMissingConfigError"] = "pipe.element.missingConfig";
    PipeErrorCodes["ElementChangeRequestRequiredError"] = "pipe.element.changeRequestRequired";
})(PipeErrorCodes || (PipeErrorCodes = {}));
//# sourceMappingURL=pipeErrorCodes.js.map